import { render, staticRenderFns } from "./statistic_product.vue?vue&type=template&id=c9f01624&scoped=true&"
import script from "./statistic_product.vue?vue&type=script&lang=js&"
export * from "./statistic_product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f01624",
  null
  
)

export default component.exports